import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ErrorDialogComponent } from '../shared/error/error-dialog.component';
import { DialogModeType } from '../shared/error/dialog-message-type.enum';
import { ErrorDialogData } from '../models/error-dialog-data.model';
import { MessageCode } from '../shared/error/user-message';

@Injectable({ providedIn: 'root' })
export class ErrorDialogService {
  private errorDialogRef: MatDialogRef<ErrorDialogComponent>;
  private readonly full_maxWidth = '100vw';
  private readonly full_maxHeight = '100vh';
  private readonly full_minWidth = '100vw';
  private readonly full_minHeight = '100vh';
  private readonly full_width = '100vw';
  private readonly full_height = '100vh';
  private readonly min_width = '500px';
  private readonly min_maxWidth = '500px';

  constructor(public dialog: MatDialog) {
  }

  public open( mode: DialogModeType, message?: string, messageCode?: MessageCode, description?: string, error?: any,
               showLoginBtn: boolean = false, fullScreen: boolean = false, disableClose: boolean = false) {

    if (this.errorDialogRef) {
      this.errorDialogRef.close();
    }

    this.errorDialogRef = this.dialog.open( ErrorDialogComponent, {
      data: new ErrorDialogData(mode, message, messageCode, error, description, showLoginBtn, disableClose),
      disableClose: disableClose,
      panelClass: 'error-dialog',
      maxWidth: fullScreen ? this.full_maxWidth : this.min_maxWidth,
      maxHeight: fullScreen ? this.full_maxHeight : undefined,
      minWidth: fullScreen ? this.full_minWidth : this.min_width,
      minHeight: fullScreen ? this.full_minHeight : undefined,
      width: fullScreen ? this.full_width : undefined,
      height: fullScreen ? this.full_height : undefined
    });
    return this.errorDialogRef.afterClosed();
  }
}
